/** @jsxImportSource @emotion/react */

import { FC } from "react";
import { css } from "@emotion/core";
import useTheme from "ui-modules/commons/hooks/use-theme";

type AboutTicketProps = {
  className?: string;
};

const Paper: FC<AboutTicketProps> = (props) => {
  const theme = useTheme();

  const { children, className } = props;

  const styles = css`
    background: ${theme.material.background};
    border-radius: 4px;
    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);
  `;

  return (
    <div css={styles} className={className}>
      {children}
    </div>
  );
};
export default Paper;
